import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResultData } from '../_models/ResultData';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(private headerService:HeaderService, private http: HttpClient) { }
  getSampleTask(id:number) :Observable<ResultData> {
    const hh = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/sampleTask/getSampleTask/${id}`,{headers:hh})

  }
  generateSampleTask(id:number) :Observable<ResultData> {
    const hh = this.headerService.bearerJsonHeaders()
    return this.http.get<any>(`${environment.apiUrl}/sampleTask/generateSampleTask/${id}`,{headers:hh})
  }

  getQuestionTemplateById(id:number) :Observable<ResultData> {
    const hh = this.headerService.bearerJsonHeaders()
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/apishow/${id}`,{headers:hh})
  }
}


